import { render, staticRenderFns } from "./AddressTest.vue?vue&type=template&id=861c834e"
import script from "./AddressTest.vue?vue&type=script&lang=ts"
export * from "./AddressTest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('861c834e')) {
      api.createRecord('861c834e', component.options)
    } else {
      api.reload('861c834e', component.options)
    }
    module.hot.accept("./AddressTest.vue?vue&type=template&id=861c834e", function () {
      api.rerender('861c834e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "admin-components/AddressTest.vue"
export default component.exports